(function () {
  function jq() {
    return window.jQuery || window.$;
  }

  function sanitizeText(input) {
    if (typeof input !== 'string') return '';
    return input.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').trim();
  }

  function sanitizeFileName(fileName) {
    if (typeof fileName !== 'string') return 'unknown_file';
    return fileName.replace(/[<>:"/\\|?*]/g, '_').replace(/\.\./g, '_').substring(0, 100).trim();
  }

  function validateFileType(file) {
    var allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    var extOk = /\.(jpe?g|png|gif)$/i.test(file.name || '');
    return allowed.indexOf(file.type) !== -1 && extOk && file.size <= 10 * 1024 * 1024;
  }

  var REASON_LABELS = {
    ordered_wrong_part: 'Ordered wrong part',
    bought_by_mistake: 'Bought by mistake',
    ordered_too_many: 'Ordered too many',
    sent_wrong_item: 'I was sent the wrong item',
    missing_parts: 'Missing parts',
    item_damaged: 'Item damaged',
    does_not_fit: 'The item does not fit',
    not_like_picture: "Doesn't match picture",
    other: 'Other'
  };

  var COMPANY_FAULT = ['sent_wrong_item', 'missing_parts', 'item_damaged', 'not_like_picture', 'other'];
  var lastFocus = null;

  function setShown(el, shown) {
    if (!el) return;
    if (shown) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function isVisible(el) {
    if (!el || el.hasAttribute('hidden')) return false;
    var parent = el.parentElement;
    while (parent) {
      if (parent.hasAttribute && parent.hasAttribute('hidden')) return false;
      parent = parent.parentElement;
    }
    return !!(el.offsetParent !== null || el.getClientRects().length);
  }

  function showErrorSummary(items) {
    var box = document.getElementById('tp-rf-errors');
    var form = document.getElementById('main_form');
    if (!box) return;
    if (!items || !items.length) {
      box.hidden = true;
      box.innerHTML = '';
      if (form) form.removeAttribute('aria-describedby');
      return;
    }
    if (form) form.setAttribute('aria-describedby', 'tp-rf-errors');
    var html = '<p><strong>Please fix the following:</strong></p><ul>';
    items.forEach(function (item) {
      var msg = sanitizeText(item.message || '');
      var id = item.id || '';
      if (id && document.getElementById(id)) {
        html += '<li><a href="#' + id + '">' + msg + '</a></li>';
      } else {
        html += '<li>' + msg + '</li>';
      }
    });
    html += '</ul>';
    box.innerHTML = html;
    box.hidden = false;
    box.focus();
  }

  function setInvalid(el, invalid) {
    if (!el) return;
    if (invalid) el.setAttribute('aria-invalid', 'true');
    else el.removeAttribute('aria-invalid');
  }

  function toggleContactSection(returnReason) {
    var contact = document.getElementById('contact-section');
    var photo = document.getElementById('photo-section');
    var details = document.getElementById('return-details-section');
    var comments = document.getElementById('return-comments-section');

    setShown(details, !!returnReason);
    setShown(comments, !!returnReason);
    setShown(contact, !!returnReason);
    setShown(photo, COMPANY_FAULT.indexOf(returnReason) !== -1);

    if (!returnReason) {
      var ud = document.getElementById('user_description');
      var rc = document.getElementById('return_comments');
      if (ud) ud.value = '';
      if (rc) rc.value = '';
    }
  }

  function togglePartNumbersSection(value) {
    var wrap = document.getElementById('part-numbers-section');
    var field = document.getElementById('part_numbers_returning');
    if (!wrap || !field) return;
    if (value === 'no') {
      setShown(wrap, true);
      field.required = true;
    } else {
      setShown(wrap, false);
      field.required = false;
      field.value = '';
    }
  }

  function updateIncomingMessage() {
    var $ = jq();
    var val = function (sel) {
      var el = document.querySelector(sel);
      return sanitizeText(el ? el.value : '');
    };
    var checked = function (name) {
      var el = document.querySelector('input[name="' + name + '"]:checked');
      return sanitizeText(el ? el.value : '');
    };

    var orderID = val('#order_id');
    var entireOrder = checked('entire_order');
    var partNumbers = val('#part_numbers_returning');
    var returnReason = checked('return_reason');
    var userDetails = val('#user_description');
    var returnComments = val('#return_comments');

    var imageCount = 0;
    for (var i = 1; i <= 4; i++) {
      var input = document.getElementById('file' + i);
      if (input && input.files && input.files.length) imageCount++;
    }

    var formattedReason = REASON_LABELS[returnReason] || returnReason || 'Not specified';
    var details = ['RETURN REQUEST DETAILS', '======================', ''];
    if (orderID) details.push('Order ID: ' + orderID);
    if (entireOrder) details.push('Returning Entire Order: ' + (entireOrder === 'yes' ? 'Yes' : 'No'));
    if (partNumbers) details.push('Part Numbers Returning: ' + partNumbers);
    if (returnReason) details.push('Reason for Return: ' + formattedReason);

    var returnDetails = userDetails;
    if (!returnDetails && returnReason) {
      returnDetails = formattedReason;
    }
    if (returnDetails) {
      details.push('', 'RETURN DETAILS:', returnDetails);
    }
    if (returnComments) {
      details.push('', 'RETURN COMMENTS:', returnComments);
    }
    if (imageCount) {
      details.push('', 'Photos Uploaded: ' + imageCount);
    }
    details.push('', 'Generated by Truth Parts Return Request Form');

    var messageField = document.getElementById('incomingmessage');
    if (messageField) {
      messageField.value = details.join('\n');
      if ($ && $(messageField).trigger) $(messageField).trigger('change');
    }

    var titleField = document.querySelector('#main_form input[name="title"]');
    if (titleField) {
      titleField.value = COMPANY_FAULT.indexOf(returnReason) !== -1
        ? 'Truth Parts - Return Request - High Priority'
        : 'Truth Parts - Return Request';
    }
  }

  function compressImage(file, maxWidth, maxHeight, quality) {
    maxWidth = maxWidth || 1200;
    maxHeight = maxHeight || 900;
    quality = quality || 0.75;
    return new Promise(function (resolve, reject) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();
      img.onload = function () {
        var width = img.width;
        var height = img.height;
        if (width > height && width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        } else if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(function (blob) {
          if (blob) resolve(blob);
          else reject(new Error('compress failed'));
        }, 'image/jpeg', quality);
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  }

  function clearSingleImage(n) {
    var fileInput = document.getElementById('file' + n);
    var fileNameDiv = document.getElementById('file-name-' + n);
    var imagePreview = document.getElementById('image-preview-' + n);
    var uploadContent = document.getElementById('upload-content-' + n);
    var imageContainer = document.getElementById('image-container-' + n);
    if (fileInput) {
      fileInput.value = '';
      fileInput.dataset.processing = 'false';
      fileInput.removeAttribute('aria-invalid');
    }
    if (fileNameDiv) fileNameDiv.textContent = '';
    if (imageContainer) imageContainer.innerHTML = '';
    if (imagePreview) imagePreview.style.display = 'none';
    if (uploadContent) uploadContent.style.display = 'flex';
  }

  function clearAllImages() {
    for (var i = 1; i <= 4; i++) clearSingleImage(i);
  }

  function updateSingleImage(input, n) {
    if (input.dataset.processing === 'true') return;
    var fileNameDiv = document.getElementById('file-name-' + n);
    var imagePreview = document.getElementById('image-preview-' + n);
    var uploadContent = document.getElementById('upload-content-' + n);
    var imageContainer = document.getElementById('image-container-' + n);
    if (!fileNameDiv || !imagePreview || !uploadContent || !imageContainer) return;

    imageContainer.innerHTML = '';
    fileNameDiv.textContent = '';
    fileNameDiv.removeAttribute('role');

    if (!input.files || !input.files.length) {
      uploadContent.style.display = 'flex';
      imagePreview.style.display = 'none';
      input.dataset.processing = 'false';
      return;
    }

    var file = input.files[0];
    if (!validateFileType(file)) {
      fileNameDiv.setAttribute('role', 'alert');
      fileNameDiv.textContent = 'Error: Invalid file or over 10MB. Use JPG or PNG.';
      fileNameDiv.style.color = '#b91c1c';
      input.value = '';
      input.setAttribute('aria-invalid', 'true');
      input.dataset.processing = 'false';
      return;
    }

    input.dataset.processing = 'true';
    input.removeAttribute('aria-invalid');
    fileNameDiv.textContent = 'Compressing: ' + sanitizeFileName(file.name);
    fileNameDiv.style.color = '#6c6cd0';

    compressImage(file).then(function (blob) {
      var firstName = (document.getElementById('firstname') || {}).value || 'customer';
      var lastName = (document.getElementById('lastname') || {}).value || 'return';
      var now = new Date();
      var stamp = now.getFullYear() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') + '_' +
        String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0');
      var newName = firstName + '_' + lastName + '_' + stamp + '.jpg';
      var compressedFile = new File([blob], newName, { type: 'image/jpeg', lastModified: Date.now() });
      var dt = new DataTransfer();
      dt.items.add(compressedFile);
      input.files = dt.files;

      fileNameDiv.textContent = 'Selected: ' + sanitizeFileName(newName) + ' (' + (blob.size / 1024 / 1024).toFixed(2) + 'MB)';
      fileNameDiv.style.color = '#166534';

      var reader = new FileReader();
      reader.onload = function (e) {
        var img = document.createElement('img');
        img.src = e.target.result;
        img.alt = 'Preview of uploaded photo ' + n;
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'remove-x';
        removeBtn.setAttribute('aria-label', 'Remove photo ' + n);
        removeBtn.textContent = '×';
        removeBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          clearSingleImage(n);
          input.focus();
        });
        imageContainer.appendChild(img);
        imageContainer.appendChild(removeBtn);
        uploadContent.style.display = 'none';
        imagePreview.style.display = 'block';
        input.dataset.processing = 'false';
      };
      reader.readAsDataURL(blob);
    }).catch(function () {
      fileNameDiv.setAttribute('role', 'alert');
      fileNameDiv.textContent = 'Could not process that image. Try another photo.';
      fileNameDiv.style.color = '#b91c1c';
      input.setAttribute('aria-invalid', 'true');
      input.dataset.processing = 'false';
    });
  }

  function fallbackValidate() {
    var items = [];
    function bad(id, msg, el) {
      items.push({ id: id, message: msg });
      setInvalid(el || document.getElementById(id), true);
    }

    document.querySelectorAll('#main_form [aria-invalid="true"]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });

    var reason = document.querySelector('input[name="return_reason"]:checked');
    if (!reason) bad('return_reason', 'Please select a reason for your return.', document.getElementById('return_reason'));

    if (isVisible(document.getElementById('return-details-section'))) {
      var ud = document.getElementById('user_description');
      if (!ud || ud.value.trim().length < 10) {
        bad('user_description', 'Please provide more details (at least 10 characters).', ud);
      }
    }
    if (isVisible(document.getElementById('contact-section'))) {
      var fn = document.getElementById('firstname');
      var ln = document.getElementById('lastname');
      var em = document.getElementById('email');
      var ph = document.getElementById('phone');
      var oid = document.getElementById('order_id');
      if (!fn || fn.value.trim().length < 2) bad('firstname', 'Please enter your first name.', fn);
      if (!ln || ln.value.trim().length < 2) bad('lastname', 'Please enter your last name.', ln);
      if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) {
        bad('email', 'Please enter a valid email address.', em);
      }
      if (!ph || ph.value.replace(/\D/g, '').length < 10) {
        bad('phone', 'Please enter a valid phone number.', ph);
      }
      if (!oid || oid.value.trim().length < 3) bad('order_id', 'Please enter your order ID.', oid);
      if (!document.querySelector('input[name="entire_order"]:checked')) {
        bad('entire_order', 'Please select whether you are returning the entire order.', document.getElementById('entire_order'));
      }
    }
    if (isVisible(document.getElementById('part-numbers-section'))) {
      var pn = document.getElementById('part_numbers_returning');
      if (!pn || pn.value.trim().length < 2) {
        bad('part_numbers_returning', 'Please enter the part numbers you are returning.', pn);
      }
    }
    if (isVisible(document.getElementById('photo-section'))) {
      var f1 = document.getElementById('file1');
      var f2 = document.getElementById('file2');
      if (!f1 || !f1.files || !f1.files.length) bad('file1', 'Please upload the first photo of your item.', f1);
      if (!f2 || !f2.files || !f2.files.length) bad('file2', 'Please upload the second photo of your item.', f2);
    }

    showErrorSummary(items);
    return items.length === 0;
  }

  function honeypotFilled() {
    var hp = document.getElementById('website');
    return !!(hp && hp.value);
  }

  function modalFocusables() {
    var modal = document.getElementById('successModal');
    if (!modal) return [];
    return Array.prototype.slice.call(modal.querySelectorAll('a[href], button:not([disabled])'));
  }

  function openSuccessModal() {
    var modal = document.getElementById('successModal');
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add('show');
    modal.setAttribute('aria-hidden', 'false');
    var home = document.getElementById('success-home');
    if (home) home.focus();
  }

  function closeSuccessModal() {
    var modal = document.getElementById('successModal');
    if (!modal) return;
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden', 'true');
    var restore = lastFocus && lastFocus.focus ? lastFocus : document.getElementById('submitter');
    if (restore) restore.focus();
  }

  function showSuccessModal() {
    var form = document.getElementById('main_form');
    if (form) form.reset();
    document.querySelectorAll('.radio-option').forEach(function (el) { el.classList.remove('selected'); });
    document.querySelectorAll('#main_form [aria-invalid="true"]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });
    showErrorSummary([]);
    clearAllImages();
    toggleContactSection('');
    var btn = document.getElementById('submitter');
    if (btn) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
      btn.textContent = 'Submit Return Request';
    }
    openSuccessModal();
  }

  function submitToNetSuite(form, btn) {
    updateIncomingMessage();
    var messageField = document.getElementById('incomingmessage');
    if (messageField && !messageField.value.trim()) {
      messageField.value = 'Return request submitted';
    }
    if (honeypotFilled()) {
      showSuccessModal();
      return;
    }

    showErrorSummary([]);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    btn.textContent = 'Submitting Return Request...';

    var data = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      body: data,
      mode: 'no-cors'
    }).then(function () {
      showSuccessModal();
    }).catch(function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
      btn.textContent = 'Submit Return Request';
      showErrorSummary([{
        id: 'submitter',
        message: 'We could not submit your request. Please try again or email support@truthparts.com.'
      }]);
    });
  }

  function markSelected(radio) {
    document.querySelectorAll('input[name="' + radio.name + '"]').forEach(function (r) {
      var opt = r.closest('.radio-option');
      if (opt) opt.classList.remove('selected');
    });
    var chosen = radio.closest('.radio-option');
    if (chosen) chosen.classList.add('selected');
  }

  function bindUploads() {
    for (var i = 1; i <= 4; i++) {
      (function (n) {
        var area = document.getElementById('upload-area-' + n);
        var input = document.getElementById('file' + n);
        if (!area || !input) return;
        input.addEventListener('change', function () { updateSingleImage(input, n); });
        ['dragenter', 'dragover'].forEach(function (evt) {
          area.addEventListener(evt, function (e) { e.preventDefault(); area.classList.add('dragover'); });
        });
        ['dragleave', 'drop'].forEach(function (evt) {
          area.addEventListener(evt, function (e) { e.preventDefault(); area.classList.remove('dragover'); });
        });
        area.addEventListener('drop', function (e) {
          if (!e.dataTransfer.files.length) return;
          input.files = e.dataTransfer.files;
          updateSingleImage(input, n);
        });
      })(i);
    }
  }

  function bindModal() {
    var modal = document.getElementById('successModal');
    var closeBtn = document.getElementById('success-close');
    if (closeBtn) closeBtn.addEventListener('click', closeSuccessModal);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeSuccessModal();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('show')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeSuccessModal();
        return;
      }
      if (e.key !== 'Tab') return;
      var nodes = modalFocusables();
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function setupValidate($) {
    if (!$ || !$.validator || !$.fn || !$.fn.validate) return false;
    $.validator.addMethod('tc_phoneUS', function (phone, el) {
      phone = (phone || '').replace(/\s+/g, '');
      return this.optional(el) || (phone.replace(/\D/g, '').length >= 10);
    }, 'Please enter a valid phone number');
    $.validator.addMethod('requiredIfVisible', function (value, element) {
      var $el = $(element);
      var $container;
      if ($el.attr('name') === 'entire_order' || $el.attr('name') === 'return_reason') {
        $container = $el.closest('.control-group');
      } else if ($el.attr('type') === 'file') {
        $container = $('#photo-section');
      } else if ($el.attr('id') === 'user_description') {
        $container = $('#return-details-section');
      } else if ($el.attr('id') === 'part_numbers_returning') {
        $container = $('#part-numbers-section');
      } else {
        $container = $('#contact-section');
      }
      if ($container.is('[hidden]') || !$container.is(':visible')) return true;
      if ($el.attr('type') === 'radio') {
        return $('input[name="' + $el.attr('name') + '"]:checked').length > 0;
      }
      if ($el.attr('type') === 'file') {
        return element.files && element.files.length > 0;
      }
      return !!(value && String(value).trim());
    }, 'This field is required');

    $('#main_form').validate({
      ignore: ':hidden',
      rules: {
        firstname: { requiredIfVisible: true, minlength: 2, maxlength: 40 },
        lastname: { requiredIfVisible: true, minlength: 2, maxlength: 40 },
        phone: { requiredIfVisible: true, tc_phoneUS: true },
        email: { requiredIfVisible: true, email: true },
        order_id: { requiredIfVisible: true, minlength: 3 },
        entire_order: { requiredIfVisible: true },
        part_numbers_returning: { requiredIfVisible: true, minlength: 2 },
        return_reason: { required: true },
        user_description: { requiredIfVisible: true, minlength: 10 },
        file1: { requiredIfVisible: true },
        file2: { requiredIfVisible: true }
      },
      messages: {
        return_reason: { required: 'Please select a reason for your return' },
        user_description: { requiredIfVisible: 'Please describe your return request', minlength: 'Please provide more details (at least 10 characters)' },
        file1: { requiredIfVisible: 'Please upload the first photo of your item' },
        file2: { requiredIfVisible: 'Please upload the second photo of your item' }
      },
      errorPlacement: function (error, element) {
        error.addClass('error');
        error.attr('role', 'alert');
        if (element.attr('type') === 'radio') {
          error.insertAfter(element.closest('.return-reason-grid, .radio-group'));
        } else if (element.attr('type') === 'file') {
          var n = element.attr('id').replace('file', '');
          var nameDiv = document.getElementById('file-name-' + n);
          if (nameDiv) error.insertAfter(nameDiv);
          else error.insertAfter(element.closest('.file-upload-container'));
        } else {
          error.insertAfter(element);
        }
      },
      highlight: function (element) {
        setInvalid(element, true);
      },
      unhighlight: function (element) {
        setInvalid(element, false);
      },
      invalidHandler: function (event, validator) {
        var items = (validator.errorList || []).map(function (err) {
          return { id: err.element.id || err.element.name, message: err.message };
        });
        showErrorSummary(items);
      },
      focusInvalid: false,
      submitHandler: function (form) {
        showErrorSummary([]);
        submitToNetSuite(form, document.getElementById('submitter'));
        return false;
      }
    });
    return true;
  }

  function init() {
    var form = document.getElementById('main_form');
    if (!form || form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    var $ = jq();
    document.querySelectorAll('#main_form input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        markSelected(this);
        if (this.name === 'return_reason') toggleContactSection(this.value);
        if (this.name === 'entire_order') togglePartNumbersSection(this.value);
        updateIncomingMessage();
      });
    });

    form.addEventListener('input', function () {
      clearTimeout(window.tpRfMsgTimer);
      window.tpRfMsgTimer = setTimeout(updateIncomingMessage, 250);
    });

    bindUploads();
    bindModal();
    updateIncomingMessage();

    var validated = false;
    if ($ && $.fn) validated = setupValidate($);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (validated && $ && $(form).valid) {
        if (!$(form).valid()) return;
        return;
      }
      if (!fallbackValidate()) return;
      submitToNetSuite(form, document.getElementById('submitter'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () {
    var form = document.getElementById('main_form');
    if (form && form.dataset.initialized !== 'true') init();
  });
})();
